import { useContext } from 'react'
import Router from 'next/router'
import { useHookForm } from 'src/hooks'
import { RootContext } from 'context/rootContext'
import { validateSchema } from './schema'
import { editUserData } from 'services/userService'
import { getToken } from 'services/registerService'
import { PAGE_URL } from 'src/utils'
import MODAL from 'src/utils/modals'
import moment from 'moment'

const useSignup = ({ defaultValues, isIncompleteRegister, onAccountCreated }) => {
  const context = useContext(RootContext)

  const onSubmitForm = async (values) => {
    context.showLoader()
    const { nameClient, birthDate, documentCpf, email, password, phone, isNewsletterOptIn, isMktsrvTermsAccepted } = values
    const { credentials } = context
    const splitName = nameClient.split(' ')
    const firstName = splitName[0]
    const lastName = splitName[1] ? splitName.slice(1).join(' ') : ''
    const momentBirthDate = moment(birthDate, 'DD/MM/YYYY', true)
    const formattedBirthDate = momentBirthDate.isValid() ? momentBirthDate.format('YYYY-MM-DD') : null
    const userData = {
      document: documentCpf.replace(/\D/g, ''),
      email: isIncompleteRegister ? undefined : email,
      password: isIncompleteRegister ? undefined : password,
      phone,
      isNewsletterOptIn,
      isMktsrvTermsAccepted,
      birthDate: formattedBirthDate,
      firstName,
      lastName
    }

    try {
      const { data } = await getToken({ email, password })
      const onSuccess = () => {
        context.toggleModalSheet({}, true)
        context.toggleWarningModal(MODAL.SUCCESS_GENERIC({
          title: isIncompleteRegister ? 'Dados salvos com sucesso' : 'Conta criada com sucesso',
          confirmLabel: 'Ir para home',
          onConfirm: () => {
            Router.push(PAGE_URL.SCHEDULING_INDEX)
            context.toggleWarningModal({ visible: false })
          }
        }))
      }
      const callback = () => context.toggleModalSheet(MODAL.CONFIRM_NEW_ACCOUNT({ ...userData, password, authenticationToken: data?.authenticationToken, successCallback: () => onAccountCreated ? onAccountCreated() : onSuccess(), onCancel: context.toggleModalSheet({}, true) }))
      if (isIncompleteRegister) {
        await editUserData(userData, credentials.authorization)
      }
      if (data) callback()
    } catch (error) {
      console.error('Erro', error)
    } finally {
      context.hideLoader()
    }
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema: validateSchema({ isIncompleteRegister }),
    defaultValues
  })

  return form
}

export default useSignup
